import { Share2 } from "lucide-react";
import { toast } from "sonner";
import { useLang } from "@/context/LanguageContext";

/**
 * ShareButton – kopierar en djuplänk till testet (eller använder
 * native Web Share API på mobil). Sätter ett ?test=<id> query-param
 * som Region.jsx läser och auto-öppnar dialogen.
 */
export default function ShareButton({ regionId, testId, testName, size = "sm" }) {
  const { t } = useLang();

  const build = () => {
    const base = `${window.location.origin}/regioner/${regionId}?test=${encodeURIComponent(testId)}`;
    return base;
  };

  const onClick = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    const url = build();
    try {
      if (navigator.share && /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)) {
        await navigator.share({ title: testName, url });
        return;
      }
      await navigator.clipboard.writeText(url);
      toast.success(t("test.shareCopied"));
    } catch (err) {
      // Fallback for very old browsers / blocked clipboard
      try {
        const ta = document.createElement("textarea");
        ta.value = url; ta.style.position = "fixed"; ta.style.opacity = "0";
        document.body.appendChild(ta); ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
        toast.success(t("test.shareCopied"));
      } catch {
        toast.error(t("test.shareFail"));
      }
    }
  };

  const sz = size === "lg" ? "size-5" : "size-3.5";

  return (
    <button
      onClick={onClick}
      title={t("test.share")}
      aria-label={t("test.share")}
      data-testid={`share-btn-${testId}`}
      className="text-muted-foreground hover:text-primary p-1 rounded-md hover:bg-muted/60 transition-colors"
    >
      <Share2 className={sz} />
    </button>
  );
}
